import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import AuthorFollowDetails from "./author_follow_details";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "AuthorFollowNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.authorFollowNewsfeedResource(),
  },

  // Return a subset of the author props for SocialUpdateBody
  // This mirrors the structure of user in gr_prop_types
  getSocialUpdateBodyUser(){
    return {
      viewableName: this.props.resource.author.name,
      profileImage: this.props.resource.author.profileImage,
      profileUrl: this.props.resource.author.profileUrl,
    };
  },

  // A link to a list of all authors the newsfeed story's user is following
  renderUserAuthorFollowingsLink() {
    return <a href={this.props.resource.userAuthorFollowingsUrl}>
             See all authors {this.props.resource.user.viewableName} is following
           </a>;
  },

  renderBody() {
    const icon = <UserIcon user={this.getSocialUpdateBodyUser()} size={ICON_SIZES.LARGE}/>;
    return (
      <SocialUpdateBody customIcon={icon}>
        <AuthorFollowDetails {...this.props.resource} />
      </SocialUpdateBody>
    );
  },

  render() {
    return <SocialUpdate
      header={<span>is now following:</span>}
      body={this.renderBody()}
      additionalFooterLinks={[this.renderUserAuthorFollowingsLink()]}
      {...this.props}
      />;
  },
});
